import isDev from './isDev';
import getEnvValue from './getEnvValue';

const isNotProdEnv =
  ['qa', 'stage', 'dev', 'qa-automation'].includes(
    getEnvValue('VITE_PROJECT_ENV'),
  ) || isDev;

export default isNotProdEnv;
